import { axiosInstance } from "config/axiosConfig";
import { NewPopupList } from "types/newPopup";

// 상세 조회
export const getPopupList = async (params: NewPopupList) => {
  const response = await axiosInstance.get("/api/popup/getPopupInfo", {
    params,
  });
  return response.data;
};
